export default "__VITE_ASSET__01bd3028__"